import React, { useState } from 'react'
import { TabbedPage, Tab } from 'components/Shared/TabbedPage'
import ChecklistSettings from 'components/ProjectConfiguration/ChecklistSettings'
import AddCheclistForm from 'components/ProjectConfiguration/Checklist/AddChecklistForm'
import { FormProvider } from 'context/FormContext';

const tabs = [
    new Tab({ label: "Settings", value: "ChecklistSettings" }),
    new Tab({ label: "Add Checklist", value: "AddChecklistForm", scope: "ProjectConfig", action: "create" }),
]

const ChecklistSettingsTabs = () => {
    const [activeTab, setActiveTab] = useState("ChecklistSettings")
    return (
        <FormProvider>
          <div  style={{paddingTop: '20px'}}>
            <TabbedPage
                tabs={tabs}
                activeTab={activeTab}
                tabSetterFunc={setActiveTab}
                elevation={0}
            >
                {(() => {
                    switch (activeTab) {
                        case "ChecklistSettings": return <ChecklistSettings  callback={() => {setActiveTab("ChecklistSettings")}}/>
                        case "AddChecklistForm": return <AddCheclistForm   callback={() => {setActiveTab("ChecklistSettings")}} />
                        default: return <ChecklistSettings />
                    }
                })()}
            </TabbedPage>
            </div>
        </FormProvider>
    )
}

export default ChecklistSettingsTabs